import { render, staticRenderFns } from "./addPotentialHouse.vue?vue&type=template&id=67a226f5&scoped=true&"
import script from "./addPotentialHouse.vue?vue&type=script&lang=js&"
export * from "./addPotentialHouse.vue?vue&type=script&lang=js&"
import style0 from "./addPotentialHouse.vue?vue&type=style&index=0&id=67a226f5&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67a226f5",
  null
  
)

export default component.exports